module.exports = __webpack_public_path__ + "img/copy-paste.fc8191d8.svg";